import PropTypes from 'prop-types'
import React, { Fragment } from 'react'

import { TextLH } from 'styles/components/typography'

import {
  Wrapper,
  IconWrapper,
  IconStyled,
  Box,
  Line,
  Info,
  Descriptions,
} from '../../styles'

import { Item, LineWrapper } from './styles'

const WHowOrderRussianBox = ({ data, paths }) => (
  <Wrapper>
    <Box alt="" src={`${paths.cdn_boxes}/wgs-opened-v15676970.png`} />
    <Descriptions>
      <Info>
        <IconWrapper className="pr-15">
          <IconStyled id="color_locker_wgs" />
        </IconWrapper>
        <TextLH dangerouslySetInnerHTML={{ __html: data.info }} />
      </Info>
      {data.opened.list.map(
        (desc, index) =>
          desc && (
            <Fragment key={index}>
              <LineWrapper className={`item-${index} line-${index} pr-15`}>
                <Line />
              </LineWrapper>
              <Item className={`item-${index}`}>
                <TextLH dangerouslySetInnerHTML={{ __html: desc }} />
              </Item>
            </Fragment>
          ),
      )}
    </Descriptions>
  </Wrapper>
)

WHowOrderRussianBox.propTypes = {
  data: PropTypes.object.isRequired,
  paths: PropTypes.object.isRequired,
}

export default WHowOrderRussianBox
